(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hg-delivery-estimate"] && !Shopify.designMode) return;
  try {
    (() => {
  function deliveryRange(now, config) {
    const {min, max, cutoff, holidays} = config;
    if (!Number.isInteger(min) || !Number.isInteger(max) || min < 1 || max < min || max > 30 || !Number.isInteger(cutoff) || cutoff < 0 || cutoff > 23) return null;
    if (holidays.some(day => !/^\d{4}-\d{2}-\d{2}$/.test(day))) return null;
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-AU', {timeZone: 'Australia/Melbourne', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23'}).formatToParts(now).map(part => [part.type, part.value]));
    const start = new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day)));
    const working = day => day.getUTCDay() !== 0 && day.getUTCDay() !== 6 && !holidays.includes(day.toISOString().slice(0, 10));
    if (Number(parts.hour) >= cutoff || !working(start)) {
      do { start.setUTCDate(start.getUTCDate() + 1); } while (!working(start));
    }
    const add = count => {
      const result = new Date(start);
      while (count > 0) { result.setUTCDate(result.getUTCDate() + 1); if (working(result)) count--; }
      return result;
    };
    return [add(min), add(max)];
  }
  function init() {
    document.querySelectorAll('[data-hg-delivery]').forEach(el => {
      if (el.dataset.ready) return;
      el.dataset.ready = 'true';
      const render = () => {
        let range = null;
        const button = el.closest('.shopify-section')?.querySelector('.product-content-container .add-to-cart:not(.hg-sticky-atc__button)');
        const eligible = el.dataset.enabled === 'true' && el.dataset.hold !== 'true' && el.dataset.eligible === 'true' && !button?.disabled;
        if (eligible) {
          try { range = deliveryRange(new Date(), {min: Number(el.dataset.min), max: Number(el.dataset.max), cutoff: Number(el.dataset.cutoff), holidays: el.dataset.holidays.split(/[\s,]+/).filter(Boolean)}); } catch { range = null; }
        }
        el.querySelector('[data-delivery-fallback]').hidden = Boolean(range);
        el.querySelector('[data-delivery-date]').hidden = !range;
        if (range) {
          const format = new Intl.DateTimeFormat('en-AU', {day: 'numeric', month: 'long', timeZone: 'UTC'});
          el.querySelector('[data-delivery-range]').textContent = range[0].getTime() === range[1].getTime() ? format.format(range[0]) : format.formatRange(range[0], range[1]);
        }
      };
      render();
      const timer = setInterval(() => { if (!el.isConnected) { clearInterval(timer); return; } render(); }, 60000);
      const button = el.closest('.shopify-section')?.querySelector('.product-content-container .add-to-cart:not(.hg-sticky-atc__button)');
      if (button) new MutationObserver(render).observe(button, {attributes: true, attributeFilter: ['disabled']});
    });
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();
  } catch(e) { console.error(e); }
})();

})();
